import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { LanguageModel } from 'src/app/core/services/api-services';
import { LanguageService as ApiLanguageService } from 'src/app/core/services/api-services';
import { LanguageService } from 'src/app/core/services/language.service';
import { MessageService } from 'src/app/core/services/message.service';
import CustomValidators from '../../core/validators/custom-validators.validator';

@Component({
    selector: 'app-council-member-detail',
    templateUrl: './council-member-detail.component.html',
    styleUrls: ['./council-member-detail.component.scss'],
    standalone: false
})

export class CouncilMemberDetailComponent implements OnInit {
  @ViewChild('formDirective') formDirective!: FormGroupDirective;
  @Input() isDiplomat!: boolean;
  @Input() isLoggedInUser!: boolean;
  @Input() isCouncilMember!: boolean;
  @Input() showAdditionalMail!: boolean;
  @Input() showMailToggle: boolean = false;
  @Input() showCorrespondenceLanguage: boolean = true;

  languages: LanguageModel[] = [];
  browserLanguage!: LanguageModel;

  constructor(@Inject(LOCALE_ID) private readonly locale: string,
    private readonly languagesService: ApiLanguageService,
    readonly languageService: LanguageService,
    private readonly messageService: MessageService) {
  }

  formGroup = new FormGroup({
    id: new FormControl<string | null>(null, { validators: [] }),
    name: new FormControl<string | null>(null, { validators: [Validators.required] }),
    prename: new FormControl<string | null>(null, { validators: [Validators.required] }),
    mail: new FormControl<string | null>(null, { validators: [CustomValidators.email, Validators.required] }),
    mobile: new FormControl<string | null>(null, { validators: [CustomValidators.internationalPhone, Validators.required] }),
    language: new FormControl<string | null>(null, { validators: [Validators.required] }),
    additionalMail: new FormControl<string | null>(null),
    personId: new FormControl<string | null>(null),
  });

  showMailToggleControl = new FormControl<boolean | null>(false);
  @Output() onShowMailToggle = new EventEmitter<boolean | null>();

  ngOnInit(): void {
    this.languagesService.getAll(false).subscribe(
      languages => {
        this.languages = languages !== null ? languages : [];
        this.browserLanguage = this.languages.find(l => l.languageCode.toUpperCase() === this.locale.toString().toUpperCase())!;

        if (!this.formGroup.controls.language.value && !this.isDiplomat) {
          this.formGroup.controls['language'].setValue(this.browserLanguage?.languageCode, { onlySelf: true });
        }
      });

    // Disabled because we don't know yet which auth service we will be using.
    if (this.isCouncilMember) {
      this.formGroup.controls.id.disable();
      this.formGroup.controls.name.disable();
      this.formGroup.controls.prename.disable();
      this.formGroup.controls.mail.disable();
      this.formGroup.controls.language.disable();
    }

    if (this.isLoggedInUser) {
      this.formGroup.controls.id.disable();
      this.formGroup.controls.name.disable();
      this.formGroup.controls.prename.disable();
      this.formGroup.controls.mail.disable();
    }

    if (this.isDiplomat) {
      this.formGroup.controls.name.enable();
      this.formGroup.controls.prename.enable();
      this.formGroup.controls.mobile.setValidators(null);
      this.formGroup.controls.language.setValidators(null);
    }
  }

  resetFormControls(): void {
    Object.keys(this.formGroup.controls).forEach(key => {
      const control = this.formGroup.get(key);
      if (control instanceof FormControl) {
        control.markAsPristine();
        control.markAsUntouched();
        control.updateValueAndValidity();
        control.setErrors(null)
      }
    });
  }

  clearForm() {
    this.formDirective.resetForm();
  }

  resetForm() {
    this.formGroup.reset();

    Object.keys(this.formGroup.controls).forEach(key => {
      const control = this.formGroup.get(key);
      control!.setErrors(null);
    });
  }
  
  mailToggleChange(): void {
    this.onShowMailToggle.emit(this.showMailToggleControl.value);
  }
}
